import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    Grid,
    TextField,
    InputAdornment,
    Divider,
} from '@material-ui/core';
import Search from '@material-ui/icons/Search';
import './FilterSelectionBar.scss';
import { fetchEmployeeGlobalSetup } from '../../store/globalSetup';
import { UPDATE_DASHBOARD_FILTERS_APP_DATA } from '../../store/appData';
import { BidProcessType } from '../../../Enums';

export const EmployeeDashboardTabs = Object.freeze({
    Active: 'Active',
    Template: 'Template',
    Archived: 'Archived',
    Assigned: 'Assigned',
});

function FilterSelectionBar() {
    const { t } = useTranslation('shiftBidding');
    const dispatch = useDispatch();

    /** @type {ShiftBidding.EmployeeStore} */
    // @ts-ignore
    const { employeeAppData } = useSelector((state) => state);
    const {
        bidProfiles,
    } = employeeAppData;
    
    // @ts-ignore
    const { 
        employeeGlobalSetup: { 
            isGlobalSetupDataLoaded,
            isEmployeesArchiveHidden
        }
    } = useSelector((state) => state);
    useEffect(() => {
        if (!isGlobalSetupDataLoaded) {
            dispatch(fetchEmployeeGlobalSetup());
        }
    }, []);

    const isTemplateTabEnabled = bidProfiles.some((x) => x.bidProcessType === BidProcessType.Preferential);
    const { selectedTab, search } = employeeAppData.employeeDashboardFilters;

    /**
     * @param {string} tab
     */
    const handleChangeTab = (tab) => {
        dispatch({
            type: UPDATE_DASHBOARD_FILTERS_APP_DATA,
            payload: {
                selectedTab: tab,
            },
        });
    };
    /**
     * @param {string} value
     */
    const handleChangeSearchValue = (value) => {
        dispatch({
            type: UPDATE_DASHBOARD_FILTERS_APP_DATA,
            payload: {
                search: value,
            },
        });
    };

    return (
        <Grid
            container
            className="filter-selection-bar"
            justifyContent="space-between"
        >
            <Grid
                item
            >
                <div
                    className={`filter-selection-bar-tabs ${selectedTab === EmployeeDashboardTabs.Active
                        ? 'filter-selection-bar-tab-selected' : ''}`}
                    onClick={() => handleChangeTab(EmployeeDashboardTabs.Active)}
                >
                    {t('employee.dashboard.tabs.active')}
                </div>
                {
                    isTemplateTabEnabled && (
                        <div
                            className={`filter-selection-bar-tabs ${selectedTab === EmployeeDashboardTabs.Template 
                                ? 'filter-selection-bar-tab-selected' : ''}`}
                            onClick={() => handleChangeTab(EmployeeDashboardTabs.Template)}
                        >
                            {t('employee.dashboard.tabs.template')}
                        </div>
                    )
                }
                <div
                    className={`filter-selection-bar-tabs ${selectedTab === EmployeeDashboardTabs.Assigned
                        ? 'filter-selection-bar-tab-selected' : ''}`}
                    onClick={() => handleChangeTab(EmployeeDashboardTabs.Assigned)}
                >
                    {t('employee.dashboard.tabs.assigned')}
                </div>
                {
                    !isEmployeesArchiveHidden && (
                        <div
                            className={`filter-selection-bar-tabs ${selectedTab === EmployeeDashboardTabs.Archived
                                ? 'filter-selection-bar-tab-selected' : ''}`}
                            onClick={() => handleChangeTab(EmployeeDashboardTabs.Archived)}
                        >
                            {t('employee.dashboard.tabs.archived')}
                        </div>
                    )
                }
            </Grid>
            <Divider />
            <Grid
                item
                className="filter-selection-bar-search-container"
                tabIndex={0}
            >
                <div
                    className="filter-selection-bar-search"
                >
                    <TextField
                        id="react-search-input"
                        placeholder="Search..."
                        size="small"
                        variant="outlined"
                        value={search}
                        onChange={(e) => handleChangeSearchValue(e.target.value)}
                        InputProps={{
                            startAdornment:
                                (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                ),
                        }}
                    />
                </div>

            </Grid>
        </Grid>
    );
}

export default FilterSelectionBar;
